import React from 'react';
import { useTranslation } from 'react-i18next';
import useCreateTitle from './useCreateTitle';
import ManageLandedCosts from '../components/Procurement/ManageLandedCosts';
import { Emo } from './EmojiIcons';
import DrawerHeader from './drawer/DrawerHeader';

// fb-37 (landed, 43027) — the last "+ Create" drawer. Rather than re-implement the money-critical
// existing-LC list + adjust/cancel, the drawer renders the proven ManageLandedCosts in STANDALONE mode:
// a searchable order picker (Combobox, date-sorted, with the existing-LC count per order), the existing
// landed costs for the picked order (with Adjust/Cancel), then the add-new form (LandedCostEntryPanel:
// Model A holding, mixed-unit guard, D2 Pool/Future catch-up). See [[ges-landed-cost-ops-playbook]].
export default function LandedCreateForm({ size, onSize, onFullPage, onClose, onInteract, params }) {
  const { t } = useTranslation('dataEntry');
  const ct = useCreateTitle();
  return (
    <>
      <DrawerHeader eyebrow={t('dataEntry:fl.purchases_landed_costs')} ini={<Emo name="ship" />} title={<>{ct('landed')}</>} size={size} onSize={onSize} onFullPage={onFullPage} onClose={onClose} />
      <div className="dr-body">
        <ManageLandedCosts operationId={(params && params.operationId) || undefined} mode={(params && params.mode) || null} landedCostId={(params && params.landedCostId) || null}
          onClose={onClose} onSuccess={() => { window.dispatchEvent(new Event('landed-costs-changed')); if (onInteract) onInteract(false); }} />
      </div>
    </>
  );
}
